import papa from 'papaparse'
import { getExpiringAudiences } from '_services/audience'

import downloadCSV from '_lib/downloadCSV.js'

export const EXCEPTED_REGIONS = ['EU-GDPR']

export const CONTENT_RULES = [
  { _id: '5eea1b7f37097dac6c04fa12', name: 'sensitive_keywords' },
  { _id: '5eea1ba937097dac6c04fa16', name: 'inappropriate_keywords' },
  { _id: '5eec0c72e48639747c9f6e7f', name: 'sensitive_keywords_eu' },
]

export const chunkArray = (array, chunkSize) => {
  const chunks = []
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize))
  }
  return chunks
}

export const getSelectedTopics = (audience) =>
  audience?.topics
    ?.concat(audience.keywords)
    ?.concat(audience.searches)
    ?.sort((a, b) => {
      return a.name?.toLowerCase() > b.name?.toLowerCase() ? 1 : -1
    })

export const isSameTopic = (a, b) => (a?._id ? a._id === b._id : a.name === b.name)

export const VERTICALS = {
  'All Verticals': [
    '/arts_&_entertainment',
    '/autos_&_vehicles',
    '/beauty_&_fitness',
    '/books_&_literature',
    '/business_&_industrial',
    '/computers_&_electronics',
    '/finance',
    '/food_&_drink',
    '/games',
    '/health',
    '/hobbies_&_leisure',
    '/home_&_garden',
    '/internet_&_telecom',
    '/jobs_&_education',
    '/law_&_government',
    '/news',
    '/online_communities',
    '/people_&_society',
    '/pets_&_animals',
    '/real_estate',
    '/reference',
    '/science',
    '/shopping',
    '/sports',
    '/travel',
  ],
  Auto: ['/autos_&_vehicles'],
  Business: ['/business_&_industrial', '/jobs', '/news', '/real_estate'],
  'Beauty & Fitness': ['/beauty_&_fitness'],
  'Consumer Electronics': ['/computers_&_electronics'],
  Education: ['/education'],
  Entertainment: [
    '/arts_&_entertainment',
    '/books_&_literature',
    '/games',
    '/hobbies_&_leisure',
    '/News > Gossip_&_Tabloid News',
    '/News > Gossip_&_Tabloid News > Scandals_&_Investigations',
  ],
  'Food & Drink': ['/food_&_drink'],
  Finance: ['/finance'],
  Health: ['/health'],
  'Home & Garden': ['/home_&_garden'],
  'Internet & Telecom': ['/internet_&_telecom'],
  Pets: ['/pets_&_animals'],
  Politics: ['/politics'],
  Retail: ['/shopping'],
  Society: [
    '/ethnicity',
    '/law_& _government',
    '/online_communities',
    '/people_&_society',
    '/reference',
    '/religion',
    '/science',
  ],
  Sports: [
    '/sports',
    '/hobbies_&_leisure > Outdoors',
    '/hobbies_&_leisure > Outdoors > Equestrian',
    '/hobbies_&_leisure > Outdoors > Fishing',
    '/hobbies_&_leisure > Outdoors > Hiking & Camping',
    '/hobbies_&_leisure > Outdoors > Hunting & Shooting',
    '/Hobbies_&_Leisure > Water Activities',
    '/Hobbies_&_Leisure > Water Activities > Boating',
    '/Hobbies_&_Leisure > Water Activities > Diving_&_Underwater Activities',
  ],
  Travel: ['/finance/insurance/travel_insurance', '/travel_&_transportation'],
}

export const getDiffKeys = (arrOne, arrTwo) => {
  const arrOneEntries = Object.entries(arrOne)
  const diffKeys = []

  arrOneEntries.forEach((entry) => {
    const key = entry[0]
    const value = entry[1]
    if (arrTwo[key] !== value) {
      diffKeys.push(key)
    }
  })

  return diffKeys
}

const hasSameNameAndSmallerSize = (array, item) =>
  array.some(
    (otherItem) => otherItem.name === item.name && otherItem.sizes.sharethis > item.sizes.sharethis
  )

const filterDuplicatedTopics = (array, arrayIndex, all) =>
  array.filter((item) => {
    const otherArrays = all.filter((_, index) => !arrayIndex === index)
    const hasRepeatedItemWithBiggerValue = otherArrays.some((array) =>
      hasSameNameAndSmallerSize(array, item)
    )

    return !hasRepeatedItemWithBiggerValue
  })

export const removeDuplicatesBasedOnSize = (topic, ...arrays) => {
  return arrays.reduce((acc, cur, curIndex, all) => {
    const filterMainTopic = removeTopicFromSuggestions(topic, cur)
    const newCur = filterDuplicatedTopics(filterMainTopic, curIndex, all)
    return [...acc, newCur]
  }, [])
}

export const removeTopicFromSuggestions = (topic, list) => {
  return list.filter((currentTopic) => currentTopic.name.toLowerCase() !== topic.name.toLowerCase())
}

export const handleFormatNumber = (number) => {
  if (number) {
    if (typeof number !== 'number') {
      return Number(number.replace(/\D/g, '')).toLocaleString('en')
    }
    return number.toLocaleString('en')
  }
  return ''
}

export const classifyPrebuiltAttributes = (attributes = []) => {
  const CLASSIFIERS = {
    netwise: 'Offline B2B Signals',
    worksin: 'Offline B2B Signals',
    psychographics: 'Psychographics',
    DEFAULT: 'Predictors',
  }
  const classified = {
    'Offline B2B Signals': [],
    Psychographics: [],
    Predictors: [],
  }
  const compare = (a, b) => {
    if (a.topicName < b.topicName) return -1
    if (a.topicName > b.topicName) return 1
    return 0
  }
  attributes.forEach((item) => {
    const sorted = { ...item, topics: item?.topics.sort(compare) }
    return CLASSIFIERS[item.attrName]
      ? classified[CLASSIFIERS[item.attrName]].push(sorted)
      : classified.Predictors.push(sorted)
  })

  return classified
}

export const extractDemographics = (audience = {}) => ({
  gender: audience.genders,
  age: audience.ages,
  income: audience.incomes,

  li_home_owner: audience.liHomeOwner || audience.li_home_owner,
  li_marital_status: audience.liMaritalStatus || audience.li_marital_status,
  li_net_worth_hh: audience.liNetWorthHh || audience.li_net_worth_hh,
  li_occupation_category: audience.liOccupationCategory || audience.li_occupation_category,
  li_dwelling_type: audience.liDwellingType || audience.li_dwelling_type,
  li_education: audience.liEducation || audience.li_education,
  li_income_hh: audience.liIncomeHh || audience.li_income_hh,
  li_political_party: audience.liPoliticalParty || audience.li_political_party,

  li_amex_card: audience.liAmexCard || audience.li_amex_card,
  li_cat_owner: audience.liCatOwner || audience.li_cat_owner,
  li_children_hh: audience.liChildrenHh || audience.li_children_hh,
  li_credit_card: audience.liCreditCard || audience.li_credit_card,
  li_dog_owner: audience.liDogOwner || audience.li_dog_owner,
  li_owns_investments: audience.liOwnsInvestments || audience.li_owns_investments,
  li_pet_owner: audience.liPetOwner || audience.li_pet_owner,
  li_premium_amex_card: audience.liPremiumAmexCard || audience.li_premium_amex_card,
  li_premium_card: audience.liPremiumCard || audience.li_premium_card,
  li_owns_stocks_and_bonds: audience.liOwnsStocksAndBonds || audience.li_owns_stocks_and_bonds,
})

export const getExpiringReport = () => {
  const fields = [
    '_id',
    'name',
    'status',
    'expiration_date_v2',
    'destinations',
    'created_at',
    'created_by',
    'updated_at',
    'updated_by',
    // integrations fields:
    'adelphic_advertiser_id',
    'adelphic_cpm',
    'appnexus_pricing_category_id',
    'appnexus_seat_id',
    'appnexus_segment_id',
    'basis_advertiser_id',
    'basis_price',
    'openx_buyer_id',
    'openx_cpm',
    'openx_demand_partner',
    'openx_deal_price',
    'openx_deal_id',
    'openx_id',
    'ttd_cpm_rate',
    'ttd_description',
    'ttd_partner_id',
    'ttd_percent_of_media_cost_rate',
    'ttd_rate_type',
    'ttd_contextual_price_id',
    'yahoo_fee',
    'yahoo_mdm_id',
    'yahoo_users',
  ]
  getExpiringAudiences({ fields })
    .then((audiences) => {
      const csv = papa.unparse({
        fields,
        data: audiences.map((audience) => ({
          _id: audience._id,
          name: audience.name,
          status: audience.status,
          expiration_date_v2: audience.expiration_date_v2,
          destinations: `"${audience.destinations.map((d) => d.name).join(', ')}"`,
          created_at: audience.created_at,
          created_by: audience.created_by.email,
          updated_at: audience.updated_at,
          updated_by: audience.updated_by.email,
          // integrations fields:
          adelphic_advertiser_id: audience.adelphic_advertiser_id,
          adelphic_cpm: audience.adelphic_cpm,
          appnexus_pricing_category_id: audience.appnexus_pricing_category_id,
          appnexus_seat_id: audience.appnexus_seat_id,
          appnexus_segment_id: audience.appnexus_segment_id,
          basis_advertiser_id: audience.basis_advertiser_id,
          basis_price: audience.basis_price,
          openx_buyer_id: audience.openx_buyer_id,
          openx_cpm: audience.openx_cpm,
          openx_demand_partner: audience.openx_demand_partner,
          openx_deal_price: audience.openx_deal_price,
          openx_deal_id: audience.openx_deal_id,
          openx_id: audience.openx_id,
          ttd_cpm_rate: audience.ttd_cpm_rate,
          ttd_description: audience.ttd_description,
          ttd_partner_id: audience.ttd_partner_id,
          ttd_percent_of_media_cost_rate: audience.ttd_percent_of_media_cost_rate,
          ttd_rate_type: audience.ttd_rate_type,
          ttd_contextual_price_id: audience.ttd_contextual_price_id,
          yahoo_fee: audience.yahoo_fee,
          yahoo_mdm_id: audience.yahoo_mdm_id,
          yahoo_users: audience.yahoo_users,
        })),
      })

      downloadCSV(csv, `expiring-audiences-${new Date().toISOString().split('T')[0]}`)
    })
    .catch((error) => {
      toast.error('Error downloading expiring report.')
    })
}
